/**
 * Harry Potter · Back to Hogwarts Landing Page
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroVideos() {
    document.querySelectorAll('[data-hp-hero] video').forEach((video) => {
      if (REDUCED) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }
      video.muted = true;
      video.playsInline = true;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });
  }

  function initScenes(root) {
    const tabs = [...root.querySelectorAll('[data-hp-tab]')];
    const scenes = [...root.querySelectorAll('[data-hp-scene]')];
    const rail = root.querySelector('[data-hp-rail]');
    const info = root.querySelector('[data-hp-info]');
    if (!scenes.length || !info) return;

    const fields = {
      set: info.querySelector('[data-info-set]'),
      exclusive: info.querySelector('[data-info-exclusive]'),
      size: info.querySelector('[data-info-size]'),
      name: info.querySelector('[data-info-name]'),
      use: info.querySelector('[data-info-use]'),
      ideal: info.querySelector('[data-info-ideal]'),
      buy: info.querySelector('[data-info-buy]'),
      empty: info.querySelector('[data-info-empty]'),
      content: info.querySelector('[data-info-content]'),
    };

    let activeSet = root.dataset.defaultSet || 'castle';
    let activeScene = null;
    let idleScene = null;

    function visibleScenes() {
      return scenes.filter((s) => s.dataset.setKey === activeSet);
    }

    function clearIdle() {
      if (idleScene) {
        idleScene.classList.remove('is-idle-hint');
        idleScene = null;
      }
    }

    function setIdleHint() {
      clearIdle();
      if (REDUCED || root.dataset.idleHint !== 'true') return;
      const first = visibleScenes()[0];
      if (!first || activeScene) return;
      idleScene = first;
      idleScene.classList.add('is-idle-hint');
    }

    function renderInfo(scene) {
      if (!scene) {
        if (fields.content) fields.content.hidden = true;
        if (fields.empty) fields.empty.hidden = false;
        return;
      }
      if (fields.content) fields.content.hidden = false;
      if (fields.empty) fields.empty.hidden = true;
      if (fields.set) fields.set.textContent = scene.dataset.setLabel || '';
      if (fields.exclusive) {
        const exclusive = scene.dataset.exclusive || '';
        fields.exclusive.textContent = exclusive;
        fields.exclusive.hidden = !exclusive;
      }
      if (fields.size) fields.size.textContent = scene.dataset.sizeLabel || '';
      if (fields.name) fields.name.textContent = scene.dataset.name || '';
      if (fields.use) fields.use.textContent = scene.dataset.useCase || '';
      if (fields.ideal) {
        const ideal = scene.dataset.idealFor || '';
        fields.ideal.innerHTML = ideal ? `<strong>Ideal für:</strong> ${ideal}` : '';
        fields.ideal.hidden = !ideal;
      }
      if (fields.buy) {
        const url = scene.dataset.productUrl || '';
        if (url) {
          fields.buy.href = url;
          fields.buy.hidden = false;
        } else {
          fields.buy.hidden = true;
          fields.buy.removeAttribute('href');
        }
      }
    }

    function activateScene(scene, { sticky = true } = {}) {
      if (!scene || scene.hidden) return;
      clearIdle();
      scenes.forEach((s) => s.classList.toggle('is-active', s === scene));
      if (rail) rail.classList.add('is-engaged');
      activeScene = sticky ? scene : activeScene;
      renderInfo(scene);
      scene.setAttribute('aria-pressed', 'true');
      scenes.forEach((s) => {
        if (s !== scene) s.setAttribute('aria-pressed', 'false');
      });
    }

    function filterSet(setKey) {
      activeSet = setKey;
      activeScene = null;
      scenes.forEach((s) => {
        const match = s.dataset.setKey === setKey;
        s.hidden = !match;
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      tabs.forEach((tab) => {
        const on = tab.dataset.hpTab === setKey;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (rail) rail.classList.remove('is-engaged');
      renderInfo(null);
      const first = visibleScenes()[0];
      if (first) activateScene(first);
      else setIdleHint();
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => filterSet(tab.dataset.hpTab));
    });

    scenes.forEach((scene) => {
      scene.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          activateScene(scene, { sticky: false });
          activeScene = scene;
        }
      });
      scene.addEventListener('focus', () => activateScene(scene));
      scene.addEventListener('click', () => activateScene(scene));
    });

    const params = new URLSearchParams(window.location.search);
    const setFromUrl = params.get('nook');
    if (setFromUrl === 'castle' || setFromUrl === 'express') {
      activeSet = setFromUrl;
    }
    if (window.location.hash === '#nook-express') activeSet = 'express';
    if (window.location.hash === '#nook-castle') activeSet = 'castle';

    filterSet(activeSet);
  }

  function resolveHpTarget(hash) {
    if (!hash || hash === '#') return null;

    const byId = document.querySelector(hash);
    if (byId) {
      return { el: byId, setKey: null };
    }

    if (hash === '#nook-castle' || hash === '#nook-express' || hash === '#szenen') {
      const parade = document.querySelector('[data-hp-parade]');
      if (parade) {
        return {
          el: parade,
          setKey: hash === '#nook-express' ? 'express' : hash === '#nook-castle' ? 'castle' : null,
        };
      }
      const shop = document.querySelector('#shop');
      if (shop) return { el: shop, setKey: null };
    }

    return null;
  }

  function goToHpTarget(hash, { updateHash = true } = {}) {
    const target = resolveHpTarget(hash);
    if (!target) return false;
    target.el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    if (target.setKey) {
      const tab = target.el.querySelector(`[data-hp-tab="${target.setKey}"]`);
      if (tab) tab.click();
    }
    if (updateHash && hash) history.replaceState(null, '', hash);
    return true;
  }

  function initSmoothAnchors() {
    document.querySelectorAll('.hp-lp a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        if (!resolveHpTarget(id)) return;
        e.preventDefault();
        goToHpTarget(id);
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-hp-faq-q]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.painta-faq__item');
        const answer = item && item.querySelector('[data-hp-faq-a]');
        if (!answer) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-hp-faq-q]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          const otherAnswer = other.closest('.painta-faq__item')?.querySelector('[data-hp-faq-a]');
          if (otherAnswer) otherAnswer.hidden = true;
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  function initShelf(root) {
    const stage = root.querySelector('[data-hp-stage]');
    const toggle = root.querySelector('[data-hp-led]');
    const status = root.querySelector('[data-hp-status]');
    const setTabs = [...root.querySelectorAll('[data-hp-nook]')];
    const scenes = [...root.querySelectorAll('[data-hp-shelf-scene]')];
    if (!stage || !toggle) return;

    let activeNook = 'castle';
    let lit = false;
    const ledOnLabel = toggle.dataset.labelOn || '';
    const ledOffLabel = toggle.querySelector('span:first-child');
    const ledOffText = (ledOffLabel && ledOffLabel.textContent) || '';

    function setStatus() {
      if (!status) return;
      const name = activeNook === 'express' ? 'Hogwarts Express' : 'Hogwarts Castle';
      status.textContent = lit
        ? `${name} · LED an – warme Magie im Regal`
        : `${name} · LED aus – schalte das Licht ein`;
    }

    function render() {
      stage.classList.toggle('is-lit', lit);
      toggle.classList.toggle('is-on', lit);
      toggle.setAttribute('aria-pressed', lit ? 'true' : 'false');
      if (ledOffLabel) {
        ledOffLabel.textContent = lit && ledOnLabel ? ledOnLabel : ledOffText;
      }
      scenes.forEach((scene) => {
        scene.hidden = scene.dataset.nook !== activeNook;
      });
      setTabs.forEach((tab) => {
        const on = tab.dataset.hpNook === activeNook;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      setStatus();
    }

    setTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activeNook = tab.dataset.hpNook || 'castle';
        render();
      });
    });

    toggle.addEventListener('click', () => {
      lit = !lit;
      render();
    });

    render();
  }

  function initLucideIcons() {
    const mount = () => {
      if (!window.lucide || typeof window.lucide.createIcons !== 'function') return false;
      window.lucide.createIcons({
        attrs: {
          'stroke-width': 1.75,
          stroke: 'currentColor',
          fill: 'none',
        },
      });
      return true;
    };

    if (mount()) return;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (mount() || tries > 40) clearInterval(timer);
    }, 50);
  }

  function initBundleAdd() {
    document.querySelectorAll('[data-hp-bundle-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (btn.disabled) return;

        const variantIds = String(btn.dataset.variants || '')
          .split(',')
          .map((id) => Number(id.trim()))
          .filter((id) => id > 0);

        if (variantIds.length < 2) return;

        const items = variantIds.map((id) => ({ id, quantity: 1 }));
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cartType = window.themeVariables?.settings?.cartType;
          const openDrawer = cartType === 'drawer';

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart } })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, openMiniCart: openDrawer },
            })
          );

          btn.textContent = variantIds.length > 2 ? 'Alle hinzugefügt' : 'Beide hinzugefügt';
          if (openDrawer) {
            const toggle = document.querySelector(
              '[data-action="toggle-drawer"][data-drawer="cart"]'
            );
            if (toggle && !toggle.classList.contains('is-active')) {
              setTimeout(() => toggle.click(), 120);
            }
          }
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = original;
          }, 2200);
        } catch (err) {
          console.error('[hp] bundle add to cart', err);
          btn.disabled = false;
          btn.textContent = original;
        }
      });
    });

    document.querySelectorAll('[data-hp-copy-code]').forEach((el) => {
      el.addEventListener('click', async () => {
        const code = el.dataset.code || el.textContent.trim();
        if (!code) return;
        const original = el.textContent;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const input = document.createElement('input');
            input.value = code;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }
          el.textContent = 'Kopiert';
          setTimeout(() => {
            el.textContent = original;
          }, 1600);
        } catch (err) {
          console.error('[hp] copy code', err);
        }
      });
    });
  }

  const FOOTPRINT_SVG =
    '<svg viewBox="0 0 32 72" fill="currentColor" aria-hidden="true">' +
    '<ellipse cx="16" cy="21" rx="13" ry="18"/>' +
    '<ellipse cx="16" cy="56" rx="9.4" ry="10.6"/>' +
    '</svg>';

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function pointOnPolyline(points, t) {
    const last = points.length - 1;
    const scaled = t * last;
    const i = Math.min(last - 1, Math.floor(scaled));
    const local = scaled - i;
    const a = points[i];
    const b = points[i + 1];
    return {
      x: lerp(a[0], b[0], local),
      y: lerp(a[1], b[1], local),
    };
  }

  function headingOnPolyline(points, t) {
    const delta = 0.02;
    const a = pointOnPolyline(points, Math.max(0, t - delta));
    const b = pointOnPolyline(points, Math.min(1, t + delta));
    return (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI + 90;
  }

  function initMapWalkers() {
    if (REDUCED || !document.querySelector('.hp-lp')) return;
    if (document.querySelector('.hp-map-walkers')) return;

    const layer = document.createElement('div');
    layer.className = 'hp-map-walkers';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    const routes = [
      [
        [6, 10],
        [16, 16],
        [26, 20],
        [36, 26],
        [46, 38],
        [56, 54],
        [68, 70],
        [80, 82],
        [92, 90],
      ],
      [
        [94, 16],
        [82, 26],
        [70, 38],
        [56, 48],
        [40, 60],
        [24, 74],
        [10, 88],
      ],
      [
        [4, 58],
        [18, 50],
        [36, 46],
        [54, 52],
        [72, 40],
        [88, 28],
        [98, 18],
      ],
      [
        [12, 86],
        [28, 72],
        [44, 58],
        [58, 42],
        [74, 28],
        [90, 14],
      ],
    ];

    const narrow = window.matchMedia('(max-width: 720px)').matches;
    const pace = narrow ? 520 : 430;
    const steps = narrow ? 9 : 12;
    let stopped = false;

    function stamp(x, y, angle, isLeft) {
      const print = document.createElement('span');
      print.className = 'hp-map-print';
      print.style.left = `${x}%`;
      print.style.top = `${y}%`;
      print.style.setProperty('--hp-print-rot', `${angle}deg`);
      print.style.setProperty('--hp-print-flip', isLeft ? '1' : '-1');
      print.style.setProperty('--hp-print-life', narrow ? '2.4s' : '2.9s');
      print.innerHTML = FOOTPRINT_SVG;
      layer.appendChild(print);
      print.addEventListener('animationend', () => print.remove(), { once: true });
    }

    async function walk(route) {
      for (let i = 0; i < steps; i += 1) {
        if (stopped) return;
        if (document.hidden) {
          await wait(400);
          i -= 1;
          continue;
        }
        const t = i / (steps - 1);
        const point = pointOnPolyline(route, t);
        const angle = headingOnPolyline(route, t);
        const rad = ((angle - 90) * Math.PI) / 180;
        const side = i % 2 === 0 ? -1 : 1;
        const offset = narrow ? 0.55 : 0.7;
        stamp(
          point.x + Math.cos(rad + Math.PI / 2) * offset * side,
          point.y + Math.sin(rad + Math.PI / 2) * offset * side,
          angle,
          side < 0
        );
        await wait(pace);
      }
    }

    async function loopWalker(route, delay) {
      await wait(delay);
      while (!stopped) {
        await walk(route);
        await wait(2600 + Math.random() * 4200);
      }
    }

    const activeRoutes = narrow ? [routes[0], routes[2]] : routes;
    activeRoutes.forEach((route, index) => {
      loopWalker(route, 600 + index * 1800);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) layer.replaceChildren();
    });
  }

  function init() {
    initHeroVideos();
    document.querySelectorAll('[data-hp-parade]').forEach(initScenes);
    document.querySelectorAll('[data-hp-faq]').forEach(initFaq);
    document.querySelectorAll('[data-hp-shelf]').forEach(initShelf);
    initBundleAdd();
    initSmoothAnchors();
    initMapWalkers();

    const hash = window.location.hash;
    if (hash === '#nook-castle' || hash === '#nook-express') {
      goToHpTarget(hash, { updateHash: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
